import { API_INSTANCE, buildURLWithState } from 'src/features/utils';
import { Attendee, EmailActivityResponse } from 'src/types/types';

export const fetchEmailDeliveryActivitiesApi = async (state: unknown, id: Attendee['id']) => {
  return await API_INSTANCE.get<EmailActivityResponse>(
    buildURLWithState(state, `/api/v1/dashboard/attendee-activity/${id}/emails`),
  );
};
